import { Typography, makeStyles } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField } from "app/components/common/TextField";
import React, { memo, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selHomebases } from "../../../slice/userSlice";
import { getAllHomebases } from "../../../slice/userThunks";

export const HomeBaseSelector = memo(
  ({ label, error, selected, disabled, onChange, disabledOption }) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const [inputValue, setInputValue] = useState("");
    const homebases = useSelector(selHomebases);
    const options = useMemo(
      () =>
        homebases?.map((homebase) => ({
          id: homebase.id,
          name: homebase.name,
          icao_code: homebase.icao_code,
        })),
      [homebases]
    );
    /* -------------------------------------------------------------------------- */
    useEffect(() => {
      dispatch(getAllHomebases());
      return () => {};
    }, []);

    useEffect(() => {
      if (!inputValue && homebases?.length) {
        let selectedBase = homebases.find((h) => h.id === selected);
        if (selectedBase) setInputValue(selectedBase.name);
      }
      return () => {};
    }, [selected, homebases]);
    /* -------------------------------- Handlers -------------------------------- */
    const handleChange = (e, newValue) => {
      onChange(newValue?.id ?? "");
      setInputValue(newValue?.name ?? "");
    };
    const handleDisabledOptions = (option) => {
      return option.id === disabledOption;
    };
    /* --------------------------------- Renders -------------------------------- */
    const renderLabel = (option) => {
      return `${option.icao_code} ${option?.name}`;
    };
    const renderOption = (option) => {
      return (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Typography className={classes.title}>{option.icao_code}</Typography>
          <Typography color="textSecondary" className={classes.subTitle}>
            {option.name}
          </Typography>
        </div>
      );
    };

    return (
      <Autocomplete
        disabled={disabled}
        onChange={handleChange}
        autoComplete={true}
        size="small"
        classes={{
          popper: classes.popper,
        }}
        inputValue={inputValue}
        noOptionsText="No results found"
        options={options}
        getOptionLabel={renderLabel}
        renderOption={renderOption}
        getOptionDisabled={handleDisabledOptions}
        style={{ width: "100%" }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            error={error}
            variant="outlined"
            onChange={(e) => {
              let value = e.target.value;
              setInputValue(value);
              const hasOption = homebases.some((option) =>
                String(`${option.icao_code} ${option.name}`).includes(value)
              );
              if (hasOption && value.length === 0) {
                onChange("");
              }
            }}
          />
        )}
      />
    );
  }
);

const useStyles = makeStyles((theme) => ({
  error: {
    color: "red",
    fontSize: 10,
  },
  popper: {
    "& .MuiAutocomplete-listbox": {
      padding: 0,
      margin: 0,
      "& li:not(:last-child)": {
        borderBottom: `1px solid ${theme.palette.grey["light"]}`,
      },
    },
  },
  title: {
    color: theme.palette.black[100],
  },
  subTitle: { fontSize: theme.typography.subtitle2.fontSize },
}));
